import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SaveViewDialog } from './SaveViewDialog';
export function SaveViewButton() {
    const [open, setOpen] = useState(false);
    return (<Fragment>
      <IconButton $round onClick={() => setOpen(true)} appearance="secondary" aria-label={t({
            message: 'Save view',
            comment: 'Save view: Save as view button',
        })}>
        <Falcon icon="layer-plus"/>
      </IconButton>
      {open && <SaveViewDialog onClose={() => setOpen(false)}/>}
    </Fragment>);
}
